import Slider from "@material-ui/core/Slider";

import useContext from "../../../context";
import { getSliderOptions } from "../../../loanConfig";

export default function RefinanceAmount() {
  const [context, updateContext] = useContext();

  const dollars = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });

  // Outdated amounts would mislead; disable the slider until current ones arrive
  const options = getSliderOptions(context, 'refinance');
  const pendingLabel = context.response.loading ? '…' : '';

  return (
    <div className="quoteform__input-group">
      <div className="quoteform__heading">Loan Amount <span className="small light">No Credit Check Option</span></div>
      <div className="quoteform__text">Tell us how much of a loan you're comfortable with.</div>
      <div className="quoteform__input quoteform__input-slider" aria-busy={!options && context.response.loading}>
          <div className="slider">
            <Slider
              aria-label="Loan amount no credit check option"
              value={context.downPaymentOption}
              disabled={!options}
              marks={[1, 2, 3].map((value) => ({ value, label: options ? dollars.format(options[value - 1]) : pendingLabel }))}
              min={1}
              max={3}
              step={1}
              onChange={(e, val) => updateContext((ctx) => {
                ctx.downPaymentOption = val;

                return ctx;
              })}
            />
          </div>
        </div>
    </div>
  )
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/RefinanceAmount.js